/* @flow */

import { call, put, takeEvery } from 'redux-saga/effects'

import type { FluxStandardAction, CustomerId } from '../../types'

import { sagaPost } from '../../fetch'
import { API_BLACKLIST } from '../../urls'
import {
  BadResponseError,
  SagaMalfunctionError,
  sagaHandleError,
  ActionRequiresPropertyError,
  UnauthorizedError,
} from '../../helpers'

import { addUrlBlacklistStore } from '../../stores/automation/blacklistStore'
import { sagaLogoutUnauthorizedUser } from '../logout'

export const ADD_BLACKLIST_URL: string = 'opinary/ADD_BLACKLIST_URL'

export function addBlacklistUrl(
  customer: CustomerId,
  url: string
): FluxStandardAction {
  return {
    type: ADD_BLACKLIST_URL,
    payload: {
      customer,
      url,
    },
  }
}

export function* sagaAddBlacklistUrl(
  action: FluxStandardAction
): Generator<*, void, *> {
  if (
    !(action && action.payload && action.payload.customer && action.payload.url)
  ) {
    throw new ActionRequiresPropertyError(
      ADD_BLACKLIST_URL,
      'payload',
      'payload.customer',
      'payload.url'
    )
  }
  try {
    const response = yield call(
      sagaPost,
      API_BLACKLIST,
      JSON.stringify(action.payload),
      { headers: { 'Content-Type': 'application/json' } }
    )
    if (response == null) throw new SagaMalfunctionError()
    if (response.status === 401 || response.status === 403) {
      yield call(sagaLogoutUnauthorizedUser)
      throw new UnauthorizedError()
    }
    if (response.status !== 201) throw new BadResponseError(response)
    const blacklistUrl = yield call([response, response.json])

    if (blacklistUrl == null) throw new SagaMalfunctionError()

    yield put(addUrlBlacklistStore(blacklistUrl))
  } catch (err) {
    yield call(sagaHandleError, err)
  }
}

export function* sagaRepeatedlyAddBlacklistUrl(): Generator<*, void, *> {
  yield takeEvery(ADD_BLACKLIST_URL, sagaAddBlacklistUrl)
}



// WEBPACK FOOTER //
// ./src/sagas/automation/addBlacklist.js